import { useAccountDetailsQuery, useBillingBalanceQuery } from 'v2/pages/billing/queries'

interface UseBalanceData {
  balance: number
  currency: string
  isPostPaid: boolean
  hasValidData: boolean
  isLoading: boolean
  hasError: boolean
}

export const useBalanceData = (): UseBalanceData => {
  const {
    data: balanceData,
    isLoading: isBalanceLoading,
    isError: isBalanceError,
  } = useBillingBalanceQuery()
  const {
    data: accountDetails,
    isLoading: isAccountLoading,
    isError: isAccountError,
  } = useAccountDetailsQuery()
  const hasValidData = !!accountDetails?.account

  return {
    balance: Number(balanceData?.amount || 0),
    currency: accountDetails?.account?.currency || 'USD',
    isPostPaid: accountDetails?.account?.postpaid || false,
    hasValidData,
    isLoading: isBalanceLoading || isAccountLoading,
    hasError: isBalanceError || isAccountError,
  }
}
